import React from 'react'

const Jva_dt = () => {
    return (
        <div className='container'>
            <td>



<h1 id="h1">Data Types in Java</h1>
<p>Data types specify the different sizes and values that can be stored in the variable. There are two types of data types in Java: </p>
<ol class="points">
<li><strong>Primitive data types:</strong> The primitive data types include boolean, char, byte, short, int, long, float and double.</li>
<li><strong>Non-primitive data types:</strong> The non-primitive data types include Classes, Interfaces, and Arrays.</li>
</ol>
<h2 class="h2">Java Primitive Data Types</h2>
<p>In Java language, primitive data types are the building blocks of data manipulation. These are the most basic data types available in Java language. </p>

<p class="n">Java is a statically-typed programming language. It means, all variables must be declared before its use. That is why we need to declare variable's type and name.</p>
<p>There are 8 types of primitive data types: </p>
<ol class="points">
<li>boolean data type</li>
<li>byte data type</li>
<li>char data type</li>
<li>short data type</li>
<li>int data type</li>
<li>long data type</li>
<li>float data type</li>
<li>double data type</li>
</ol>
<img src="https://static.javatpoint.com/images/java-data-types.png" alt="Java Data Types"/>

<table class="alt"> 
<tbody><tr> 
  <th id="table_dvpt_datatype"><strong>Data Type</strong></th> 
  <th id="table_dvpt_defaultvalue"><strong>Default Value</strong></th> 
  <th id="table_dvpt_defaultsize"><strong>Default size</strong></th> 

</tr> 
 
<tr> 
<td headers="table_dvpt_datatype">boolean</td> 
<td headers="table_dvpt_defaultvalue">false</td> 
<td headers="table_dvpt_defaultsize">1 bit</td> 
</tr> 

<tr> 
<td headers="table_dvpt_datatype">char</td> 
<td headers="table_dvpt_defaultvalue">'\u0000'</td> 
<td headers="table_dvpt_defaultsize">2 byte</td> 
</tr> 

<tr> 
<td headers="table_dvpt_datatype">byte</td> 
<td headers="table_dvpt_defaultvalue">0</td> 
<td headers="table_dvpt_defaultsize">1 byte</td> 

</tr> 
 
<tr> 
<td headers="table_dvpt_datatype">short</td> 
<td headers="table_dvpt_defaultvalue">0</td> 
<td headers="table_dvpt_defaultsize">2 byte</td> 
</tr> 
 
<tr> 
<td headers="table_dvpt_datatype">int</td> 
<td headers="table_dvpt_defaultvalue">0</td> 
<td headers="table_dvpt_defaultsize">4 byte</td> 
</tr> 
 
<tr> 
<td headers="table_dvpt_datatype">long</td> 
<td headers="table_dvpt_defaultvalue">0L</td> 
<td headers="table_dvpt_defaultsize">8 byte</td> 
</tr> 
 
<tr> 
<td headers="table_dvpt_datatype">float</td> 
<td headers="table_dvpt_defaultvalue">0.0f</td> 
<td headers="table_dvpt_defaultsize">4 byte</td> 
</tr> 
 
<tr> 
<td headers="table_dvpt_datatype">double</td> 
<td headers="table_dvpt_defaultvalue">0.0d</td> 
<td headers="table_dvpt_defaultsize">8 byte</td> 
</tr> 
</tbody></table> 

<h2 class="h2">Boolean Data Type</h2>
<p>The Boolean data type is used to store only two possible values: true and false. This data type is used for simple flags that track true/false conditions. </p>
<p>The Boolean data type specifies one bit of information, but its "size" can't be defined precisely.</p> 
<p><strong>Example:</strong> Boolean one = false</p>
<h2 class="h2">Byte Data Type </h2>
<p>The byte data type is an example of primitive data type. It isan 8-bit signed two's complement integer. Its value-range lies between -128 to 127 (inclusive). Its minimum value is -128 and maximum value is 127. Its default value is 0. </p>
<p>The byte data type is used to save memory in large arrays where the memory savings is most required. It saves space because a byte is 4 times smaller than an integer. It can also be used in place of "int" data type. </p>
<p><strong>Example:</strong> byte a = 10, byte b = -20</p>
<h2 class="h2">Short Data Type </h2>
<p>The short data type is a 16-bit signed two's complement integer. Its value-range lies between -32,768 to 32,767 (inclusive). Its minimum value is -32,768 and maximum value is 32,767. Its default value is 0. </p>
<p>The short data type can also be used to save memory just like byte data type. A short data type is 2 times smaller than an integer. </p>
<p><strong>Example:</strong> short s = 10000, short r = -5000</p>
<h2 class="h2">Int Data Type</h2>
<p>The int data type is a 32-bit signed two's complement integer. Its value-range lies between - 2,147,483,648 (-2^31) to 2,147,483,647 (2^31 -1) (inclusive). Its minimum value is - 2,147,483,648and maximum value is 2,147,483,647. Its default value is 0. </p>
<p>The int data type is generally used as a default data type for integral values unless if there is no problem about memory.</p>
<p><strong>Example:</strong> int a = 100000, int b = -200000</p>
<h2 class="h2">Long Data Type </h2>
<p>The long data type is a 64-bit two's complement integer. Its value-range lies between -9,223,372,036,854,775,808(-2^63) to 9,223,372,036,854,775,807(2^63 -1)(inclusive). Its minimum value is - 9,223,372,036,854,775,808and maximum value is 9,223,372,036,854,775,807. Its default value is 0. The long data type is used when you need a range of values more than those provided by int.</p>
<p><strong>Example:</strong> long a = 100000L, long b = -200000L</p>
<h2 class="h2">Float Data Type</h2>
<p>The float data type is a single-precision 32-bit IEEE 754 floating point.Its value range is unlimited. It is recommended to use a float (instead of double) if you need to save memory in large arrays of floating point numbers. The float data type should never be used for precise values, such as currency. Its default value is 0.0F.</p>
<p><strong>Example:</strong> float f1 = 234.5f</p>
<h2 class="h2">Double Data Type </h2>
<p>The double data type is a double-precision 64-bit IEEE 754 floating point. Its value range is unlimited. The double data type is generally used for decimal values just like float. The double data type also should never be used for precise values, such as currency. Its default value is 0.0d.</p>
<p><strong>Example:</strong> double d1 = 12.3</p>
<h2 class="h2">Char Data Type</h2>
<p>The char data type is a single 16-bit Unicode character. Its value-range lies between '\u0000' (or 0) to '\uffff' (or 65,535 inclusive).The char data type is used to store characters. </p>
<p><strong>Example:</strong> char letterA = 'A'</p>
<hr/>
<h3 class="h2">Why char uses 2 byte in java and what is \u0000 ?</h3>
<p>It is because java uses Unicode system not ASCII code system. The \u0000 is the lowest range of Unicode system. To get detail explanation about Unicode visit next page.
</p>


</td>
        </div>
    )
}

export default Jva_dt
